import axios from "../../../util/axios";

/**
 * 审批中心
 *
 * 工作流引擎与实例数据都在 basedata 服务（wf_flow_* 五张表都在那个库），
 * 所以这里直接打 basedata 的 process/flow，不经过 project 服务中转 ——
 * 中转一层只是把同样的数据搬一遍，还要为跨越服务再定义一套 DTO。
 */
const PREFIX_URI = "/basedata/process/flow";

export default {
    /** 顶部四张统计卡（待我处理 / 我发起的 / 已通过 / 已驳回）——以我为维度 */
    queryStat: (data) => axios.get({url: `${PREFIX_URI}/stat/queryStat`, data: data}),

    /** 工作流统计（进行中 / 已完成 / 已中止）——以流程为维度，统计全商户 */
    queryWorkflowStat: (data) => axios.get({url: `${PREFIX_URI}/workflow/queryStat`, data: data}),
    /** 工作流列表：按流程实例分页 */
    queryWorkflowList: (data) => axios.get({url: `${PREFIX_URI}/workflow/queryList`, data: data}),

    /** 待我处理（分页） */
    queryTodo: (data) => axios.get({url: `${PREFIX_URI}/todo/queryList`, data: data}),
    /** 我已处理（分页） */
    queryDone: (data) => axios.get({url: `${PREFIX_URI}/done/queryList`, data: data}),
    /** 我发起的（分页） */
    queryStarted: (data) => axios.get({url: `${PREFIX_URI}/started/queryList`, data: data}),
    /** 抄送我的（分页） */
    queryCopied: (data) => axios.get({url: `${PREFIX_URI}/copied/queryList`, data: data}),

    /** 流程实例详情：含完整流转轨迹与只读流程图 */
    findInstanceDetail: (instanceId) => axios.get({url: `${PREFIX_URI}/instance/findById`, data: {instanceId: instanceId}}),

    /**
     * 按任务id查单条任务。
     * 实例详情的 taskList 只放当前待办，点开一条已处理的任务时要在那里找不到，
     * 得单独按 id 取。
     */
    findTask: (taskId) => axios.get({url: `${PREFIX_URI}/task/findById`, data: {taskId: taskId}}),

    /**
     * 按业务键查流程实例（含流转轨迹）。
     * 业务单据页用它查「这张单子的审批走到哪了」—— 它手里只有自己的单据 id，
     * 没有流程实例 id。单据没走过流程时返回 null。
     */
    findByBusiness: (businessType, businessKey) =>
        axios.get({url: `${PREFIX_URI}/instance/findByBusiness`, data: {businessType, businessKey}}),

    /**
     * 审批所需的业务数据（弹框里展示的单据内容）。
     * 前端只调这一个接口，由引擎代为回调业务服务并做参与者鉴权 ——
     * 审批人不需要拥有业务模块的访问权。
     */
    queryBusinessDetail: (instanceId) => axios.get({url: `${PREFIX_URI}/instance/queryBusinessDetail`, data: {instanceId: instanceId}}),

    /** 审批通过 */
    pass: (data) => axios.post({url: `${PREFIX_URI}/task/pass`, data: data}),
    /** 审批驳回 */
    reject: (data) => axios.post({url: `${PREFIX_URI}/task/reject`, data: data}),
    /** 完成业务节点 */
    completeBusiness: (data) => axios.post({url: `${PREFIX_URI}/task/completeBusiness`, data: data}),
    /** 中止流程：彻底停下不再流转，与驳回（打回重改）不同 */
    abort: (data) => axios.post({url: `${PREFIX_URI}/task/abort`, data: data}),
    /** 确认抄送（不影响流程流转，只把通知从待办里摘掉） */
    confirmCopy: (data) => axios.post({url: `${PREFIX_URI}/task/confirmCopy`, data: data}),
    /** 认领任务 */
    claim: (taskId) => axios.get({url: `${PREFIX_URI}/task/claim`, data: {taskId: taskId}}),
    /** 转办 */
    transfer: (data) => axios.post({url: `${PREFIX_URI}/task/transfer`, data: data}),
    /** 加签 */
    addSign: (data) => axios.post({url: `${PREFIX_URI}/task/addSign`, data: data}),
}
